import { InMemoryCacheConfig } from '@apollo/client/core';

import { cursorBasedPagination, pageBasedPagination } from '../helper';

/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Global InMemoryCache configuration use for initial Apollo InMemoryCache configuration
 */
export const IN_MEMORY_CACHE_CONFIG: InMemoryCacheConfig = {
  typePolicies: {
    Query: {
      fields: {
        billingAddresses: cursorBasedPagination(['customerId']),
        contacts: cursorBasedPagination(),
        customerCareNotes: pageBasedPagination(['orderBy']),
        fleetQuotations: pageBasedPagination(['filter']),
        loggedInContext: {
          merge: true
        },
        orders: pageBasedPagination(['filter']),
        shippingAddresses: cursorBasedPagination(['customerId']),
        shoppingLists: pageBasedPagination(['filter', 'orderBy']),
        eVouchers: pageBasedPagination(['filter', 'orderBy']),
        eVoucherCampaignRestrictedAccountsConfiguration: pageBasedPagination(['filter'], 'originId'),
        eVoucherAccountRestrictedAccountsConfiguration: pageBasedPagination(['filter'], 'originId'),
        standardQuotations: pageBasedPagination(['filter']),
        storeConfiguration: {
          merge: true
        },
        tools: pageBasedPagination(['filter', 'orderBy']),
        repairNotifications: pageBasedPagination(['filter', 'orderBy']),
        purchaseRequests: pageBasedPagination(['filterInput']),
        softwareSubscription: {
          merge: true
        },
        consumptionProducts: pageBasedPagination(['filter']),
        searchEditorials: pageBasedPagination(['filter']),
        searchTechnicalDocuments: pageBasedPagination(['filter']),
        searchSoftwareFaq: pageBasedPagination(['filter']),
        searchVideos: pageBasedPagination(['filter'])
      }
    },
    Account: {
      keyFields: ['originId'],
      fields: {
        address: {
          merge: true
        }
      }
    },
    Address: {
      fields: {
        formatted: {
          merge: false
        }
      }
    },
    Discount: {
      keyFields: false
    },
    FleetQuotation: {
      keyFields: ['id', 'totalPrice', ['amount']]
    },
    FormFieldValue: {
      keyFields: false
    },
    Order: {
      fields: {
        deliveryInformation: {
          merge: true
        }
      }
    },
    PurchaseRequest: {
      fields: {
        deliveryInformation: {
          merge: true
        }
      }
    },
    Tool: {
      keyFields: false
    },
    SalesUnit: {
      keyFields: false
    },
    StandardQuotation: {
      keyFields: ['id', 'totalPrice', ['amount']]
    },
    StoreConfiguration: {
      fields: {
        common: {
          merge: true
        }
      }
    },
    SoftwareSubscription: {
      fields: {
        users: {
          merge(_existing, incoming: []) {
            return incoming;
          }
        }
      }
    }
  }
};
